<template>
    <b-card no-body>

        <b-modal id="create-pdf" size="lg" title="HGS Başvuru PDF Oluştur" no-close-on-esc no-close-on-backdrop>
            <is-bankasi-hgs-application-pdf-create v-model="pdf"></is-bankasi-hgs-application-pdf-create>
            <template #modal-footer><v-executer :loading="loading" text="PDF Oluştur" :action="createPdf"></v-executer></template>
        </b-modal>

        <b-modal id="send" size="lg" title="HGS Başvurusunu İlet" no-close-on-esc no-close-on-backdrop>
            <is-bankasi-hgs-application-send v-model="application"></is-bankasi-hgs-application-send>
            <template #modal-footer><v-executer :loading="loading" text="İlet" :action="sendApplication"></v-executer></template>
        </b-modal>

        <b-modal id="detail" size="lg" title="HGS Başvurusu Detayı" no-close-on-esc hide-footer no-close-on-backdrop>
            <is-bankasi-hgs-application-detail v-model="detail"></is-bankasi-hgs-application-detail>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    name="isbankasi-hgsa"
                    :fields="fields"
                    pagination="server"
                    button-alignment="text-left"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'

import Additional from '@/utilities/additional'
import IsbankasiHGSOperationApi from '@/api/isbankasi-hgs-operations'
import IsBankasiHGSApplicationPDFCreate from './components/IsBankasiHGSApplicationPDFCreate.vue'
import IsBankasiHGSApplicationSend from './components/IsBankasiHGSApplicationSend.vue'
import IsBankasiHGSApplicationDetail from './components/IsBankasiHGSApplicationDetail.vue'

export default {
    components:{
        BCard,
        'is-bankasi-hgs-application-pdf-create':IsBankasiHGSApplicationPDFCreate,
        'is-bankasi-hgs-application-send':IsBankasiHGSApplicationSend,
        'is-bankasi-hgs-application-detail':IsBankasiHGSApplicationDetail
    },
    data(){
        return{
            pdf:{
                CreditCardNumber:null,
                DeliveryPersonFullName:null,
                PlateOfHGSApplicationModels:[],
            },
            application:{
                Id:null,
                ApplicationText:"",
                Attachment:null,
                ToMailAddress:null
            }, 
            detail:{
                ApplicationCode: null,
                ApplicationText:null,
                CreatedBy:null,
                CreditCardNumber:null,
                DeliveryPersonFullName:null,
                Id:null,
                IsSent:null,
                PlatesOfHGSApplications:[],
                SentTime:null
            },
            fields:[
                {name:"Başvuru No", key:"ApplicationCode",thClass:'w-20'},
                {name:"Kredi Kartı", key:"CreditCardNumber",thClass:'w-20'},
                {name:"Teslim Edilecek Kişi", key:"DeliveryPersonFullName",thClass:'w-20'},
                {name:"İşlemi Yapan", key:"CreatedBy",thClass:'w-20'},
                {name:"İşlem Tarihi", key:"SentTime",thClass:'w-20'},
            ],       
            buttons:[
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"primary",action:this.download },
                { text:"İmzalı Belgeyi İndir",key:"download-signed",icon:"DownloadIcon",variant:"warning",action:this.downloadSigned, condition:(item) => item.IsSent },
                { text:"İlet",key:"send",icon:"SendIcon",variant:"success",action:this.send,condition:(item) => !item.IsSent },
                { text:"Detay",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.showDetail},
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete,condition:(item) => !item.IsSent },
            ],      
            loading:false
        }
    },
    methods:{
        clearForm(){
            this.application.ApplicationText = ""
            this.application.Id = null
            this.application.Attachment = null
            this.application.ToMailAddress = null
            this.pdf.CreditCardNumber = null
            this.pdf.DeliveryPersonFullName = null
            this.pdf.PlateOfHGSApplicationModels = []
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-pdf')
        },
        provider(data){
            return IsbankasiHGSOperationApi.Application.Table(data)
        },
        download(item,btnKey,index,bool){
            let id = bool ? item : item.Id
            if(!bool) this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.Application.DownloadPDF(id).then(_res=>{
                Additional.DownloadFile(_res.data,'HGSBaşvuru.pdf')
                if(bool){
                    this.$hideModal('create-pdf')
                    this.loading = false
                }else this.$refs.table.rowLoading(false)
            }).catch(err=>{
                if(bool){
                    this.loading = false
                }else this.$refs.table.rowLoading(false)
            })
        },
        downloadSigned(item){
            this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.Application.DownloadSignedPDF(item.Id).then(_res=>{
                Additional.DownloadFile(_res.data,'HGSBaşvuru.pdf')
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        createPdf(){
            this.loading = true
            IsbankasiHGSOperationApi.Application.CreatePDF(this.pdf).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.download(res.data.Data,null,null,true)
                    this.$refs.table.refresh()
                }
                this.loading = false
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        send(item){
            this.clearForm()
            this.application.Id = item.Id
            this.$showModal('send')
        },
        showDetail(item){
            this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.Application.Get(item.Id).then(res=>{
                this.detail.ApplicationCode = res.data.Data.ApplicationCode
                this.detail.ApplicationText = res.data.Data.ApplicationText
                this.detail.CreatedBy = res.data.Data.CreatedBy
                this.detail.CreditCardNumber = res.data.Data.CreditCardNumber
                this.detail.DeliveryPersonFullName = res.data.Data.DeliveryPersonFullName
                this.detail.Id = res.data.Data.Id
                this.detail.IsSent = res.data.Data.IsSent
                this.detail.PlatesOfHGSApplications = res.data.Data.PlatesOfHGSApplications
                this.detail.SentTime = res.data.Data.SentTime
                this.$showModal('detail')
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        async sendApplication(){
            this.loading = true
            let formData = await Additional.ToFormData(this.application,['Attachment'])
            IsbankasiHGSOperationApi.Application.Send(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('send')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.ApplicationCode} numaralı başvuruyu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    IsbankasiHGSOperationApi.Application.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    },
}
</script>

<style>

</style>